import { render } from "./AddBlog.vue?vue&type=template&id=629dbde2"
import script from "./AddBlog.vue?vue&type=script&lang=js"
export * from "./AddBlog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__